// File: frontend/src/contexts/AuthContext.js
import React, { createContext, useState, useContext } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Changed from login to signIn
  const signIn = async (credentials) => {
    setIsLoading(true);
    try {
      console.log('Signing in with:', credentials);
      setIsAuthenticated(true);
      setUser({ id: 1, name: 'User' });
    } catch (error) {
      console.error('Sign in error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // Changed from logout to signOut
  const signOut = () => {
    setUser(null);
    setIsAuthenticated(false);
  };

  // Added signUp function
  const signUp = async (userData) => {
    setIsLoading(true);
    try {
      console.log('Signing up with:', userData);
      setIsAuthenticated(true);
      setUser({ id: 1, name: userData.name || 'User' });
    } catch (error) {
      console.error('Sign up error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthContext.Provider value={{
      user,
      isAuthenticated,
      isLoading,
      signIn,  // Changed from login
      signOut, // Changed from logout
      signUp   // Added new function
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
